/**
 * 複数のオーバーレイ（Modal / Drawer）を同時に開いても
 * 最後の 1 枚が閉じたときに正しく body スクロールを復元するための参照カウンタ
 */
let lockCount = 0;
let savedOverflow: string | null = null;

export function acquireScrollLock() {
  if (lockCount === 0) {
    savedOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
  }
  lockCount += 1;
}

export function releaseScrollLock() {
  if (lockCount === 0) return;
  lockCount -= 1;
  if (lockCount === 0) {
    document.body.style.overflow = savedOverflow ?? '';
    savedOverflow = null;
  }
}
